import mediumZoom from 'medium-zoom';

const elements = document.querySelectorAll('.js-zoomable');

const zoomImage = function() {
  if (elements === null) {
    return;
  }

  mediumZoom(elements, {
    background: 'rgba(255, 255, 255, 0.9)',
  });
};

export default zoomImage;



// WEBPACK FOOTER //
// ./src/scripts/modules/zoom-image.js